import { FC, Fragment } from 'react';

import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { CreatePartnerButton } from './createPartnerButton/CreatePartnerButton';
import { DraggablePartnerCards } from './draggablePartnerCards/DraggablePartnerCards';

import css from './PartnersPage.module.css';

import { partnersService } from 'v2/api/partnersService';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';

export const PartnersPage: FC = () => {
  const { data, isLoading, mutate } = useSWR('getPartners', partnersService.getPartners);

  return (
    <PageLayout className={css.partnersPage} overflow="hidden">
      <PageTitle action={<CreatePartnerButton onSuccess={mutate} />}>Partners Settings</PageTitle>

      <div className={css.partnersPageContent}>
        {isLoading ? (
          <Loader />
        ) : (
          isNonNullish(data) && (
            <Fragment>
              {isEmpty(data) ? <EmptyPlaceholder /> : <DraggablePartnerCards partners={data} onRevalidate={mutate} />}
            </Fragment>
          )
        )}
      </div>
    </PageLayout>
  );
};
